import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "feedback"]
  static values = { success: String }

  async copy(event) {
    event.preventDefault()
    const text = this.hasSourceTarget ? this.sourceTarget.textContent.trim() : this.element.dataset.clipboardText
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
      this.showFeedback()
    } catch {
      window.prompt("", text)
    }
  }

  showFeedback() {
    if (!this.hasFeedbackTarget) return

    this.feedbackTarget.hidden = false
    window.clearTimeout(this.feedbackTimer)
    this.feedbackTimer = window.setTimeout(() => {
      this.feedbackTarget.hidden = true
    }, 2000)
  }

  disconnect() {
    window.clearTimeout(this.feedbackTimer)
  }
}
